export default __webpack_public_path__ + "static/media/pr_c_29.2d28ed86.jpg";